import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Panel } from 'react-bootstrap';
import TimelineChart from './TimelineChart';
import { loadFormsAnalyticsData } from './actions';
import { withNamespaces } from 'react-i18next';
import FontAwesome from 'react-fontawesome';

class ChildDashboard extends Component {
	componentDidMount() {
		this.reloadData(this.props.childId);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.childId !== this.props.childId) {
			this.reloadData(nextProps.childId);
		}
	}

	reloadData(childId) {
		if (childId) {
			const { loadFormsAnalyticsData } = this.props;
			const requestData = { childId };

			loadFormsAnalyticsData('hemisphericAnalysis', requestData);
			loadFormsAnalyticsData('sensorAnalysis', requestData);
			loadFormsAnalyticsData('coreStabilityAssessment', requestData);
			loadFormsAnalyticsData('primitiveReflexAssessment', requestData);
		}
	}

	render() {
		const {
			currentUser,
			analytics: {
				hemisphericAnalysis,
				sensorAnalysis,
				coreStabilityAssessment,
				primitiveReflexAssessment
			},
			t
		} = this.props;

		
		return <div>
			<Row>
				<Col sm={12} md={12}>
					<Panel>
						<Panel.Heading><FontAwesome name='bar-chart' /> {t('ChildDashboard_SensorAnalysis')}</Panel.Heading>
						<Panel.Body>
							<TimelineChart {...sensorAnalysis} name='SensorAnalysis'
								keys={['vestibularFunction', 'auditoryFunction', 'visualDysfunction', 'proprioceptiveFunction', 'hypotactileSymptom', 'hypertactileSymptom', 'hypersensitiveSmell', 'hyposensitiveSmell', 'total']} />
						</Panel.Body>
					</Panel>
				</Col>
				<Col sm={12} md={12}>
					<Panel>
						<Panel.Heading><FontAwesome name='bar-chart' /> {t('ChildDashboard_HemisphericAnalysis')}</Panel.Heading>
						<Panel.Body>
							<TimelineChart {...hemisphericAnalysis} name='HemisphericAnalysis'
								keys={['right.total', 'left.total', 'rightAndLeft.total', 'rightToLeft']} />
						</Panel.Body>
					</Panel>
				</Col>
			</Row>
			<Row>
				<Col sm={12} md={12}>
					<Panel>
						<Panel.Heading><FontAwesome name='bar-chart' /> {t('ChildDashboard_HemisphericAnalysisRight')}</Panel.Heading>
						<Panel.Body>
							<TimelineChart {...hemisphericAnalysis} name='HemisphericAnalysisRight'
								keys={['right.motor', 'right.sensory', 'right.emotional', 'right.behavioral', 'right.academic', 'right.immune', 'right.autonomic']} />
						</Panel.Body>
					</Panel>
				</Col>

				<Col sm={12} md={12}>
					<Panel>
						<Panel.Heading><FontAwesome name='bar-chart' /> {t('ChildDashboard_HemisphericAnalysisLeft')}</Panel.Heading>
						<Panel.Body>
							<TimelineChart {...hemisphericAnalysis} name='HemisphericAnalysisLeft' 
								keys={['left.motor', 'left.sensory', 'left.emotional', 'left.behavioral', 'left.academic', 'left.immune', 'left.autonomic']} />

						</Panel.Body>
					</Panel>
				</Col>
			</Row>
			<Row>
				<Col sm={12} md={12}>
					<Panel>
						<Panel.Heading><FontAwesome name='bar-chart' /> {t('ChildDashboard_HemisphericAnalysisRightAndLeft')}</Panel.Heading>
						<Panel.Body>
							<TimelineChart {...hemisphericAnalysis} name='HemisphericAnalysisRightAndLeft'
								keys={['rightAndLeft.motor', 'rightAndLeft.sensory', 'rightAndLeft.emotional', 'rightAndLeft.behavioral', 'rightAndLeft.academic', 'rightAndLeft.immune', 'rightAndLeft.autonomic']} />

						</Panel.Body>
					</Panel>
				</Col>
			</Row>
			<Row>
				<Col sm={12} md={12}>
					<Panel>
						<Panel.Heading><FontAwesome name='bar-chart' /> {t('ChildDashboard_PrimitiveReflexAssessment')}</Panel.Heading>
						<Panel.Body>
							<TimelineChart {...primitiveReflexAssessment} name='PrimitiveReflexAssessment' 
								keys={['tlr', 'moro', 'stnr']} />
						</Panel.Body>
					</Panel>
				</Col>
				<Col sm={12} md={12}>
					<Panel>
						<Panel.Heading><FontAwesome name='bar-chart' /> {t('ChildDashboard_PrimitiveReflexAssessmentLR')}</Panel.Heading>
						<Panel.Body>
							<TimelineChart {...primitiveReflexAssessment} name='PrimitiveReflexAssessmentLR'
								keys={['right.atnrStanding', 'right.atnrKneeling', 'right.spinalGalant', 'right.palmer', 'right.rooting', 'right.babinsky',
									'left.atnrStanding', 'left.atnrKneeling', 'left.spinalGalant', 'left.palmer', 'left.rooting', 'left.babinsky']} />
						</Panel.Body>
					</Panel>
				</Col>
			</Row>
			<Row>
				<Col sm={12} md={12}>
					<Panel>
						<Panel.Heading><FontAwesome name='bar-chart' /> {t('ChildDashboard_CoreStabilityAssessment')}</Panel.Heading>
						<Panel.Body>
							<TimelineChart {...coreStabilityAssessment} name='CoreStabilityAssessment'
								keys={['bridgePosition', 'curlUps', 'lateralCore', 'proneCore', 'pushUps', 'brachiation', 'aerobicExercise']} />
						</Panel.Body>
					</Panel>
				</Col>	
				<Col sm={12} md={12}>
					<Panel>
						<Panel.Heading><FontAwesome name='bar-chart' />{t('ChildDashboard_PostrotatoryNystagmus')}</Panel.Heading>
						<Panel.Body>
							<TimelineChart {...coreStabilityAssessment} name='PostrotatoryNystagmus'
								keys={['postrotatoryNystagmus']} />
						</Panel.Body>
					</Panel>
				</Col>

			</Row>
		</div>;
	}
}

const mapStateToProps = (state) => {
	const {
		formsAnalytics: { melillo }
	} = state;

	return {
		analytics: melillo
	};
};

export default connect(mapStateToProps, {
	loadFormsAnalyticsData
})(withNamespaces('formAnalytics.Melillo.resources')(ChildDashboard));